export enum IFormStatus {
	Completed = 0,
	Canceled = 1,
	ValidationError = 2
}
